import React, { useEffect, useState } from 'react';
import { Col, Image, Row, Spin, Typography } from 'antd';
import { API_BASE_URL, AUTH_TOKEN } from '../../../../../config/config';

const { Text } = Typography;

interface CommitmentImagesProps {
  idControl: number;
  imageIndex?: number;
}

const CommitmentImages: React.FC<CommitmentImagesProps> = ({ idControl, imageIndex = 0 }) => {
  const [mainImage, setMainImage]         = useState<string | null>(null);
  const [optionalImage, setOptionalImage] = useState<string | null>(null);
  const [loading, setLoading]             = useState(false);

  useEffect(() => {
    if (!idControl) return;
    fetchImages();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idControl]);

  const fetchBlob = async (url: string): Promise<string | null> => {
    try {
      const token = localStorage.getItem(AUTH_TOKEN);
      const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) return null;
      return URL.createObjectURL(await res.blob());
    } catch {
      return null;
    }
  };

  const fetchImages = async () => {
    setLoading(true);
    const base = `${API_BASE_URL}/api/v1`;
    const [main, optional] = await Promise.all([
      fetchBlob(`${base}/comms/control/get_commitment_image/${idControl}`),
      fetchBlob(`${base}/comms/control/get_commitment_image_optional/${idControl}`),
    ]);
    setMainImage(prev => { if (prev) URL.revokeObjectURL(prev); return main; });
    setOptionalImage(prev => { if (prev) URL.revokeObjectURL(prev); return optional; });
    setLoading(false);
  };

  const activeImage = imageIndex === 0 ? mainImage : optionalImage;
  const activeLabel = imageIndex === 0 ? 'Imagen principal' : 'Imagen opcional';

  return (
    <Spin spinning={loading}>
      <Row>
        <Col span={24}>
          {activeImage ? (
            <>
              <Text type="secondary" style={{ fontSize: 11, display: 'block', marginBottom: 4 }}>
                {activeLabel}
              </Text>
              <Image src={activeImage} preview={false} style={{ width: '100%' }} />
            </>
          ) : (
            !loading && (
              <Text type="secondary" style={{ fontSize: 12 }}>Sin imagen disponible</Text>
            )
          )}
        </Col>
      </Row>
    </Spin>
  );
};

export default CommitmentImages;
